import { ProcessGeneral } from 'api/endpoints/processes';
import BaseRepo from 'container/BaseRepo';
import { buildBadRequestApiError } from 'container/helpers/errors';
import { ApiResponseAsync } from 'container/models';
import { SearchRequest } from 'container/search';

import {
  IPrintRenderOverridesRepo,
  ResponseType,
} from './IPrintRenderOverrides';

export class PrintRenderOverridesRepo
  extends BaseRepo
  implements IPrintRenderOverridesRepo
{
  getCount(
    draft: ProcessGeneral,
    request: SearchRequest
  ): ApiResponseAsync<number> {
    const link = draft._links?.['getPrintRenderDistributions'];
    if (!link) {
      return Promise.resolve(
        buildBadRequestApiError(
          new Error('link "get print render distributions" is not available')
        )
      );
    }

    request.count = true;

    return this.helpers.executeSearch(link, request);
  }

  getRows(
    draft: ProcessGeneral,
    request: SearchRequest
  ): ApiResponseAsync<ResponseType> {
    const link = draft._links?.['getPrintRenderDistributions'];
    if (!link) {
      return Promise.resolve(
        buildBadRequestApiError(
          new Error('link "get print render distributions" is not available')
        )
      );
    }

    request.count = false;

    return this.helpers.executeSearch(link, request);
  }
}
